
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PageName extends Vue {
    @Prop() title: string;
    @Prop() customClass: string;

}
